<template>
    <div class="px-5 d2d-onboarding">
        <div v-if="!onboardingstatus" class="row d2d-header mb-5">
            <div class="col-md-12 pt-4">
                <h1>
                    You've declined the agreement. If you change your mind, you can sign up at any time.
                </h1>
            </div>
            <div class="col-md-12 d2d-h-subtitle pt-2">
                
            </div>
        </div>
        <template v-else>
            <div class="row d2d-header mb-5">
                <div class="col-md-12 pt-4">
                    <h1>
                        Thank You For Signing Up For the Dealer Commission Program!
                    </h1>
                </div>
                <div class="col-md-12 d2d-h-subtitle pt-2">
                    <span>EARN COMMISSION</span> ON SUPPRESSOR SALES FROM
                    <a href="https://www.silencerco.com" target="_blank">
                        SILENCERCO.COM
                    </a>
                </div>
            </div>
            <div class="section mt-5">
                <div class="row">
                    <div class="col-md-12 p-0">
                        <h2>Next Steps:</h2>
                    </div>
                    <div>
                        <p>
                            The SilencerCo team will review your signup details and
                            agreement and then proceed with setting up your Dealer
                            Commission Program. This process is usually pretty quick
                            and once completed your dealership will show up on the
                            SilencerCo.com website and a preferred dealer in our FFL
                            locator that is used by customers during the checkout
                            process. <br /><br />
                            If you have any additional questions, please reach out
                            to your sales rep or email
                            <a href="mailto:sales@silencerco.com"
                                >sales@silencerco.com</a
                            >.
                        </p>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    props: ['onboardingstatus'],
    emits: [],
    components: {},
    setup() {},
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>
<style scoped lang="scss">
.d2d-header {
    text-align: center;
    background: #ededed;
    padding: 20px;
    border-radius: 30px;
    h1 {
        font-size: 2rem;
        color: #000000;
    }
    .d2d-h-subtitle {
        font-size: 1.6rem;
        font-weight: 600;
        color: #000000;
        span {
            font-weight: 800;
            font-family: "TT-Norms-ExtraBold";
        }
    }
}

.d2d-onboarding {
    @media (max-width: 600px) {
        width: 100%;
        padding: 1rem !important;
    }
    width: 80%;
    margin: auto;
    h2 {
        font-size: 2rem;
        color: #000000;
    }

    .step-container {
        display: flex;
        gap: 20px;
        margin-top: 10px;
        margin-bottom: 20px;
        .step-sub-container {
            @media (max-width: 600px) {
                width: 100%;
                padding: 1rem !important;
            }

            padding: 25px;
            background: #2d2b29;
            display: flex;
            color: white;
            gap: 20px;
            border-radius: 12px;
            width: 49%;
            flex: 1;
            .step-holder {
                .step-text {
                    font-size: 28px;
                    font-family: "TT-Norms-ExtraBold";
                }
                .step-number {
                    font-size: 50px;
                    color: #ff7f00;
                    font-family: "TT-Norms-ExtraBold";
                    margin-top: -25px;
                }
            }
            .step-info {
                width: 80%;
                margin: auto;
                font-size: 22px;
                span {
                    color: #ff7f00;
                }
            }
        }
    }

    .d2d-btn {
        width: 225px;
        height: 45px;
        border-radius: 50px;
        background: #ff7f00;
        color: white;
        border-color: #ff7f00;
        font-weight: 500;
        border: 1px solid #ff7f00;
        padding: 10px 30px;
        &:hover {
            color: #ff7f00;
            background-color: transparent;
        }
        font-family: "TT-Norms-ExtraBold";
    }

    a {
        color: #ff7f00;
        text-decoration: none;
    }

    ol {
        padding: 0;
        font-size: 18px;
        line-height: 2rem;
        color: black;
        padding-left: 5px;
    }
    p {
        color: black;
    }
    h2 {
        span {
            color: #ff7f00;
        }
    }
    .accordion-button {
        font-size: 25px;
    }

    .accordion {
        max-width: 550px;
        margin-left: 45px;
        margin-top: 10px;
        @media (max-width: 600px) {
            margin-left: 0px;
        }
    }

    .accordion-button:not(.collapsed) {
        background: none;
        color: #ff7f00;
    }
    .accordion-button.collapsed::after {
        content: "";
        display: block;
        box-sizing: border-box;
        position: absolute;
        width: 15px;
        height: 15px;
        border-bottom: 3px solid;
        border-right: 3px solid;
        transform: rotate(45deg);
        left: 4px;
        top: 30%;
        background-image: unset;
        right: 25px;
        color: #ff7f00;
    }

    .accordion-button:not(.collapsed)::after {
        content: "";
        display: block;
        box-sizing: border-box;
        position: absolute;
        width: 15px;
        height: 15px;
        border-bottom: 3px solid;
        border-right: 3px solid;
        transform: rotate(225deg);
        left: 4px;
        top: 40%;
        background-image: unset;
        right: 25px;
        color: #ff7f00;
    }
    .accordion-item {
        border: unset;
        border-top: 2px solid #efefefef;
    }
    .theader {
        font-size: 18px;
        color: #bcbcbc;
        margin-bottom: 5px;
    }
    .tbody {
        font-size: 18px;
        color: #000000;
    }
    .starred {
        vertical-align: baseline;
        margin-left: 5px;
        margin-right: 5px;
        width: 12px;
    }
    .high-earner {
        font-size: 12px;
        color: #ff7f00;
        font-style: italic;
    }
    .accordion-body {
        .trow {
            border-top: 1px solid #fefe;
            padding-top: 5px;
            padding-bottom: 5px;
        }
    }
}
</style>
